import { createThreadApi } from '@shared-ui/threads';
import type { ThreadApiClient } from '@shared-ui/threads';
import { fetchWithAdmin } from './fetchHelper';

const client: ThreadApiClient = {
    fetchApi: <T>(endpoint: string, options?: RequestInit) => fetchWithAdmin<T>(endpoint, options),
};

export const adminThreadApi = createThreadApi(client, { basePath: '/console/threads' });

/** User-scope threadApi (basePath `/threads`) for routes the admin still calls
 *  as an authenticated user — e.g. /threads/unread-count for the nav badge. */
export const threadApi = createThreadApi(client);
